import styled, { css } from 'react-emotion'
import { mobile } from './styleguide'

const justifyMap = {
  start: 'flex-start',
  end: 'flex-end',
  'space-between': 'space-between',
  'space-around': 'space-around',
}

const alignMap = {
  start: 'flex-start',
  end: 'flex-end',
  'space-between': 'space-between',
  'space-around': 'space-around',
  stretch: 'stretch',
}

const Box = styled.div`
  display: flex;
  justify-content: ${props => justifyMap[props.justify] || 'center'};
  align-items: ${props => alignMap[props.align] || 'center'};
  flex-wrap: ${props => (props.wrap ? 'wrap' : ' no-wrap')};
  flex-grow: ${props => (props.grow ? 1 : 0)};
  width: 100%;
  position: relative;
`
export const Row = styled(Box)`
  flex-direction: row;
  ${props =>
    mobile(
      css`
        flex-direction: ${props.break === 'reverse'
          ? 'column-reverse'
          : props.break ? 'column' : 'row'};
      `
    )};
`

export const Column = styled(Box)`
  flex-direction: column;
`

export default Box



// WEBPACK FOOTER //
// ../styleguide/src/Box.jsx